import {
    FETCH_CHILD_COHORT_SURVEY_DATA_START,
    FETCH_CHILD_COHORT_SURVEY_DATA_SUCCESS,
    FETCH_CHILD_COHORT_SURVEY_DATA_FAIL,

} from "../../../constants";
import {
    FETCH_COHORT_CHILD_SURVEYS_URL,
} from "../../../../../config/constants";
import { ApiBase } from "../../../../utils/apiBase";
import { withType } from "../../../../utils/actionOperations";
import { getProjectIdAndOrgId } from '../../../../utils/apiUtils';

export const fetchChildCohortSurveyList = (payload, cb) => {
    const apiBaseInstance = new ApiBase().instance;
    const sortOrder = {
        asc: "ascend",
        desc: "descend",
    }
    return (dispatch) => {
        dispatch(
            withType(FETCH_CHILD_COHORT_SURVEY_DATA_START, { ...payload, sortOrder: payload.sortOrder ? sortOrder[payload.sortOrder] : undefined })
        );
        return apiBaseInstance
            .post(FETCH_COHORT_CHILD_SURVEYS_URL, {
                ...payload, ...getProjectIdAndOrgId(payload)
            })
            .then((res) => {
                dispatch(
                    withType(FETCH_CHILD_COHORT_SURVEY_DATA_SUCCESS, {
                        data: res.data,
                        payload: payload
                    })
                );
                cb && cb()
            })
            .catch((err) => {
                dispatch(withType(FETCH_CHILD_COHORT_SURVEY_DATA_FAIL, { ...err, ...payload }));
                cb && cb()
            });
    };
};

